<mat-label class="subHeading">Active Partners<span *ngIf="isRequired" class="star">*</span></mat-label>
<div formGroupName="active_partners" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="9" type="text" class="w-50 m-0" placeholder="From" appNumberOnly [wholeNumberOnly]="true">
    -
    <input formControlName="to" [maxlength]="9" type="text" class="w-50 m-0" placeholder="To" appNumberOnly [wholeNumberOnly]="true">
</div>
